class Security {
    constructor(data) {
        this.passwordLivePage = data?.passwordLivePage || '';
        this.passwordLivePageActive = data?.passwordLivePageActive || false;
    }
}

export default Security;
